export interface ErrorResponseData {
  detail: string;
  status: number;
  title: string;
  type: string;
}

export class Status {
  //#region Auth
  authLoading: boolean = false;
  authErrorMsg: string = '';
  //#endregion

  //#region User
  userLoading: boolean = false;
  userErrorMsg: string = '';
  registerUserLoading: boolean = false;
  registerUserErrorMsg: string = '';
  //#endregion

  //#region API Keys
  createApiKeysLoading: boolean = false;
  getApiKeysLoading: boolean = false;
  deleteApiKeysLoading: boolean = false;
  apiKeysErrorMsg: string = '';
  //#endregion

  //#region Database
  getMaschineLoading: boolean = false;
  maschineErrorMsg: string = '';
  //#endregion

  //#region FehlerLogs
  getFehlerLogLoading: boolean = false;
  fehlerLogErrorMsg: string = '';
  //#endregion

  //#region Paletten
  getPaletteLoading: boolean = false;
  paletteErrorMsg: string = '';
  //#endregion

  //#region Produktionsauftraege
  getProduktionsauftragLoading: boolean = false;
  produktionsauftragErrorMsg: string = '';
  //#endregion
}

export enum SortDirection {
  asc,
  desc,
}

export class PagedRequest {
  page: number = 1;
  pageSize: number = 25;
  sortBy: string = '';
  sortDirection: SortDirection = SortDirection.asc;
  filter: string = '';
}

export interface PagedResult<T> {
  items: Array<T>;
  pageIndex: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}
